import { api, ApiResponse } from "../lib/api.ts";
import { CreatePostRequest, UpdatePostRequest, PostResponse, PostDetailResponse } from "../entry/server/post.ts";

export const postServer = {
    createPost: async (post: CreatePostRequest): Promise<ApiResponse<PostResponse>> => {
        const formData = new FormData();
        formData.append("title", post.title);
        formData.append("content", post.content);
        formData.append("is_published", post.is_published);
        formData.append("thumbnail", post.thumbnail);
        return await api.post<PostResponse>({ url: "posts", formData: formData });
    },
    updatePost: async (id: number, post: UpdatePostRequest): Promise<ApiResponse<PostResponse>> => {
        const formData = new FormData();
        formData.append("title", post.title);
        formData.append("content", post.content);
        formData.append("is_published", post.is_published);
        if (post.thumbnail) {
            formData.append("thumbnail", post.thumbnail);
        }
        return await api.put<PostResponse>({ url: `posts/${id}`, formData: formData });
    },
    getPosts: async (page: number): Promise<ApiResponse<PostResponse[]>> => {
        return await api.get<PostResponse[]>({ url: "posts", queryParams: { "page": page.toString() } });
    },
    getPost: async (id: number): Promise<ApiResponse<PostDetailResponse>> => {
        return await api.get<PostDetailResponse>({ url: `posts/${id}` });
    },
    deletePost: async (id: number): Promise<ApiResponse<void>> => {
        return await api.delete<void>({ url: `posts/${id}` });
    },
}